import React from "react";
import { ErrorMessage, Formik } from "formik";
import {
  Alert,
  Form,
  Card,
  Row,
  Col,
  Accordion,
  Button,
} from "react-bootstrap";
import * as Yup from "yup";
import { getInputClasses } from "../../../_utils/getInputclasses";
import AlertError from "../../../components/AlertError";
import { update } from "../../services/hospitalizationcrud";

export const MedicAssigned = (props) => {
  return (
    <>
      <Card>
        <Card.Header>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey={props.eventKey}
          >
            DATOS MÉDICO TRATANTE
          </Accordion.Toggle>
          <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
        </Card.Header>
        <Accordion.Collapse eventKey={props.eventKey}>
          <Card.Body>
            <ContentMedicAssigned {...props} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export const ContentMedicAssigned = (props) => {
  return (
    <>
      <Alert
        variant="dark"
        className="text-center mt-4"
        style={{ fontSize: "14px" }}
      >
        DATOS MÉDICO TRATANTE
      </Alert>

      <Card>
        <Card.Body>
          <FormMedicAssigned {...props} />
        </Card.Body>
      </Card>
    </>
  );
};

export const FormMedicAssigned = (props) => {
  const initialValues = {
    treatmentDoctorName: props.data.treatmentDoctorName || "",
    treatmentDoctorPhone: props.data.treatmentDoctorPhone || "",
    treatmentDoctorSpecialty: props.data.treatmentDoctorSpecialty || "",
    treatmentDoctorEmail: props.data.treatmentDoctorEmail || "",
    doctorsNetId: props.data.doctorsNetId || "",
  };

  const { id } = props.data;
  const { bindSubmitForm } = props;

  const handleSubmitForm = (values, { setStatus, setSubmitting }) => {
    update({ ...props.data, ...values }, id).then((response) =>
      console.log("Form medic assigned inside saved")
    );
  };

  const validationSchema = Yup.object().shape({
    treatmentDoctorName: Yup.string()
      .required("El campo es obligatorio"),
    treatmentDoctorPhone: Yup.string()
      .required("El campo es obligatorio"),
    treatmentDoctorSpecialty: Yup.string()
      .required("El campo es obligatorio"),
    treatmentDoctorEmail: Yup.string()
      .required("El campo es obligatorio"),
  });

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={handleSubmitForm}
      validationSchema={validationSchema}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        status,
        isSubmitting,
        submitForm,
      }) => {
        bindSubmitForm(submitForm)
        return (
          <>
            <AlertError status={status} />
            <Form id="formu4" onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <Form.Group controlId="treatmentDoctorName">
                    <Form.Label>MÉDICO Tratante *</Form.Label>
                    <Form.Control
                      type="text"
                      name="treatmentDoctorName"
                      value={values.treatmentDoctorName}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "treatmentDoctorName"
                      )}`}
                    />
                    <ErrorMessage name="treatmentDoctorName">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="treatmentDoctorPhone">
                    <Form.Label>TELÉFONO *</Form.Label>
                    <Form.Control
                      type="number"
                      name="treatmentDoctorPhone"
                      value={values.treatmentDoctorPhone}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      onKeyDown={ (evt) => evt.key === 'e' && evt.preventDefault() }
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "treatmentDoctorPhone"
                      )}`}
                    />
                    <ErrorMessage name="treatmentDoctorPhone">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="treatmentDoctorSpecialty">
                    <Form.Label>ESPECIALIDAD MÉDICO TRATANTE *</Form.Label>
                    <Form.Control
                      type="text"
                      name="treatmentDoctorSpecialty"
                      value={values.treatmentDoctorSpecialty}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "treatmentDoctorSpecialty"
                      )}`}
                    />
                    <ErrorMessage name="treatmentDoctorSpecialty">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group controlId="treatmentDoctorEmail">
                    <Form.Label>Email MÉDICO Tratante *</Form.Label>
                    <Form.Control
                      type="email"
                      name="treatmentDoctorEmail"
                      value={values.treatmentDoctorEmail}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "treatmentDoctorEmail"
                      )}`}
                    />
                    <ErrorMessage name="treatmentDoctorEmail">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="doctorsNetId">
                    <Form.Label>Red</Form.Label>
                    <Form.Control
                      as="select"
                      name="doctorsNetId"
                      value={values.doctorsNetId}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "doctorsNetId"
                      )}`}
                    >
                      <option value="">SELECCIONA UNA OPCIÓN...</option>
                      <option value="1">MÉDICO de red</option>
                      <option value="2">MÉDICO de no red</option>
                      <option value="3">Convenio</option>
                    </Form.Control>
                    <ErrorMessage name="doctorsNetId">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};
